import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message", "button", "content", "icon"]

  initialize() {
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  connect() {
    const submitButton = this.element.querySelector('button[type="submit"]')

    if (submitButton) {
      const formId = submitButton.getAttribute('form')
      if (formId) {
        const form = document.getElementById(formId)
        if (form) {
          form.addEventListener('submit', this.handleSubmit)
        }
      }
    }

    if (this.buttonTarget.getAttribute("aria-expanded") === "true") {
      this.contentTarget.classList.remove("hidden")
    }
  }

  toggle(event) {
    event.preventDefault()

    const isExpanded = this.buttonTarget.getAttribute("aria-expanded") === "true"
    this.buttonTarget.setAttribute("aria-expanded", String(!isExpanded))

    if (isExpanded) {
      this.contentTarget.classList.add("hidden")
    } else {
      this.contentTarget.classList.remove("hidden")
    }
  }

  disconnect() {
    const submitButton = this.element.querySelector('button[type="submit"]')

    if (submitButton) {
      const formId = submitButton.getAttribute('form')
      if (formId) {
        const form = document.getElementById(formId)
        if (form) {
          form.removeEventListener('submit', this.handleSubmit)
        }
      }
    }
  }

  handleSubmit(event) {
    event.preventDefault()

    const form = event.target
    const formData = new FormData(form)

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.json())
    .then(data => {
      this.showMessage(data)
    })
    .catch(error => {
      console.error('Error:', error)
      this.showMessage({
        status: 'error',
        message: 'Error al procesar la solicitud'
      })
    })
  }

  showMessage(data) {
    const messageDiv = this.messageTarget
    messageDiv.classList.remove('hidden')
    messageDiv.innerHTML = data.banner_html

    setTimeout(() => {
      messageDiv.classList.add('hidden')
    }, 3000)
  }
}
